// @ts-check
import { getStore } from 'shared/stash';

const UPDATE_PENDING_REFERRALS_COUNT = 'UPDATE_PENDING_REFERRALS_COUNT';
export { UPDATE_PENDING_REFERRALS_COUNT };

const actions = {
  updatePendingReferralsCount(payload) {
    getStore().dispatch({ type: UPDATE_PENDING_REFERRALS_COUNT, payload });
  },
};

export default actions;
